export default __webpack_public_path__ + "static/viinitie-banner-corporate-desktop-wide.a4b5acbe0c1d38cf7d655e45d740907d.jpg";